import { render, staticRenderFns } from "./PageMapping.vue?vue&type=template&id=8e245396&scoped=true&"
import script from "./PageMapping.vue?vue&type=script&lang=js&"
export * from "./PageMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e245396",
  null
  
)

export default component.exports